import {imgRefCliente} from '../../db/config';
import firebase from "firebase";

export const updateImages =  (id,file) => {

    return new Promise((resolve, reject) => {
        
      console.log("Utils.uploadSegImg fileArray: ", file);
      
        const storageRef = imgRefCliente.child(`${id}/foto_perfil`);
     
  
  
        const task = storageRef.put(
         file
        );
        task.on(
          "state_changed",
          (snapshot) => {
            switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                  console.log('Upload is paused');
                  break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                  console.log('Upload is running');
                  break;
              }
        },
        (error) => {
            console.error(error.message);
            reject(error.message);
        },
        async () => {
           resolve(storageRef.getDownloadURL())
          }
        );
  
    });
  };
